
import React from "react";
import { Paper, Stack, Typography } from "@mui/material";

export default function AccountSidebar({
                                           items = [],
                                           activeIndex = 0,
                                           onSelect,
                                       }) {
    return (
        <Paper
            elevation={0}
            sx={{
                borderRadius: "20px",
                backgroundColor: "#F0F0F0",
                p: 3,
                minHeight: 260,
            }}
        >
            <Stack spacing={1.5}>
                {items.map((text, index) => {
                    const isActive = index === activeIndex;

                    return (
                        <Typography
                            key={text}
                            onClick={() => onSelect && onSelect(index)}
                            sx={{
                                fontFamily: "'Roboto Condensed', sans-serif",
                                fontSize: 14,
                                lineHeight: "120%",
                                cursor: "pointer",
                                fontWeight: isActive ? 700 : 400,
                                color: isActive ? "#E5007E" : "#111111",
                                transition: "0.15s ease",
                                "&:hover": {
                                    color: isActive ? "#E5007E" : "#444",
                                },
                            }}
                        >
                            {text}
                        </Typography>
                    );
                })}
            </Stack>
        </Paper>
    );
}
